import humm from './humm.theme.json';
import kiski from './kiski.theme.json';
import prism from './prism.theme.json';

export const generatedThemes = {
  humm,
  kiski,
  prism,
};
